import React, { Fragment } from "react";
import { Typography, Box, useTheme } from "@mui/material";
import { Helmet } from "react-helmet";
import { getStyleForThankyouResponse } from "../styles/commonStyles";

const ThankyouResponse = () => {
  const theme = useTheme();
  const classes = getStyleForThankyouResponse(theme);

  return (
    <Fragment>
      <Helmet>
        <title>Thank You Response</title>
      </Helmet>
      <Box component="div" sx={classes.wrapper}>
        <Typography sx={classes.title} variant="h5">
          Thanks for your response.
        </Typography>
        <Typography sx={classes.bdyTxt}>
          We’ve sent this information back to your provider so they may update
          your record.
        </Typography>
      </Box>
    </Fragment>
  );
};
export default ThankyouResponse;
